import { defineStore } from "pinia";
import { ref, computed, onMounted, watch } from 'vue';

import { useStore } from 'vuex';
import { supabase } from '@/supabase';


import { formatarDataHora } from '@/utils/formatarDataHora';
import { ordenarArrayDeObjetos } from "@/utils/ordenarArrayDeObjetos";


export const useCadernoStore = defineStore('cadernoStore', () => {
    const storeVuex = useStore();
    const turma = computed(() => storeVuex.state.turma);
    const anotacoesBrutas = ref([]);
    const anotacoes = ref([]);
    const datasComRegistro = ref([]);
    const alunosSemAnotacoes = ref(false);
    const planosComAnotacoes = ref([]);
    const opcoesPlanos = ref([]);
    const planosSelecionados = ref([]);


    async function listarAnotacoes() {
        storeVuex.dispatch('updateLoading', true)
        const { data, error } = await supabase
            .from('estudantes_turmas')
            .select('idDaTurma,users(id, nome, img, caderno(id,titulo,anotacao, plano, aula, created_at, comentario, feedback_comentario))')
            .order('created_at', {
                foreignTable: 'users.caderno',
                ascending: false
            }
            )
            .eq('idDaTurma', turma.value.idDaTurma)
            .eq('users.caderno.aula', turma.value.idDaAula)


        if (error) {
            alert('Ocorreu um erro ao carregar os estudantes: ' + error.message)
            return
        }
        storeVuex.dispatch('updateLoading', false)
        anotacoesBrutas.value = data;

        organizarAnotacoesPorDataMaisRecente();
    }

    async function listarPlanos() {
        const { data, error } = await supabase
            .from('planos')
            .select('titulo, id')
            .in('id', planosComAnotacoes.value)

        opcoesPlanos.value = data;
        console.log(opcoesPlanos.value)

        if (error) {
            console.log('Ocorreu um erro ao carregar os planos: ' + error.message)
            return
        }
    }

    function organizarAnotacoesPorDataMaisRecente() {
        let dados = [...anotacoesBrutas.value];

        let anotacoesLocais = [];
        dados.forEach(estudante => {
            let anotacoesEstudante = { id: estudante.users.id, nome: estudante.users.nome, imagem: estudante.users.img, anotacoes: [] }
            if (estudante.users.caderno.length > 0) {
                let numeroDaAnotacao = 1;
                estudante.users.caderno.forEach(caderno => {
                    if (numeroDaAnotacao < 2) {
                        anotacoesEstudante.anotacoes.push({ id: caderno.id, titulo: caderno.titulo, anotacao: caderno.anotacao, data: caderno.created_at, titulo: caderno.titulo, comentario: caderno.comentario, condicao: 'exibir', comentarioSalvo: true, plano: caderno.plano, feedback_comentario: caderno.feedback_comentario })
                    } else {
                        anotacoesEstudante.anotacoes.push({ id: caderno.id, titulo: caderno.titulo, anotacao: caderno.anotacao, data: caderno.created_at, titulo: caderno.titulo, comentario: caderno.comentario, condicao: 'ocultar', comentarioSalvo: true, plano: caderno.plano, feedback_comentario: caderno.feedback_comentario })
                    }

                    if (datasComRegistro.value.length == 0) {
                        datasComRegistro.value.push(formatarDataHora(caderno.created_at, 'data'))
                    } else {
                        const dataNotava = datasComRegistro.value.find(data => data == formatarDataHora(caderno.created_at, 'data'))
                        if (dataNotava == undefined) {
                            datasComRegistro.value.push(formatarDataHora(caderno.created_at, 'data'))
                        }
                    }

                    if(planosComAnotacoes.value.length == 0){
                        planosComAnotacoes.value.push(caderno.plano)
                    }else{
                        if(planosComAnotacoes.value.includes(caderno.plano)){
                            caderno.plano
                        }else{
                            planosComAnotacoes.value.push(caderno.plano)
                        }
                    }
                    numeroDaAnotacao++;
                })
            }
            anotacoesLocais.push(anotacoesEstudante);
        })

        anotacoesLocais = ordenarArrayDeObjetos(anotacoesLocais, 'nome');
        anotacoesBrutas.value = anotacoesLocais;
        anotacoes.value = anotacoesLocais;
        listarPlanos();
        ordenarDatas(datasComRegistro.value);
        console.log(anotacoes.value)
    }

    function atualizarStatusDoComentario(idAnotacao, status){
        console.log(idAnotacao, status)
        anotacoes.value.forEach(estudante => {
            estudante.anotacoes.forEach(anotacao => {
                if(anotacao.id == idAnotacao){
                    anotacao.comentarioSalvo = status
                }
            })
        })
    }

    async function atualizarComentario(id, comentario) {

        const { data, error } = await supabase
            .from('caderno')
            .update({ comentario: comentario })
            .eq('id', id)


        if (error) {
            alert('Ocorreu um erro ao salvar o comentário: ' + error.message)
        }else{
            atualizarStatusDoComentario(id, true)
        }
    }

    function ordenarDatas(datas) {
        return datas.sort((a, b) => {
            const [diaA, mesA, anoA] = a.split('/');
            const [diaB, mesB, anoB] = b.split('/');

            const dataA = new Date(`${anoA}-${mesA}-${diaA}`);
            const dataB = new Date(`${anoB}-${mesB}-${diaB}`);

            return dataB - dataA;
        });
    }

    return { anotacoes, datasComRegistro, anotacoesBrutas, alunosSemAnotacoes, opcoesPlanos, planosSelecionados, listarAnotacoes, atualizarComentario, atualizarStatusDoComentario };
})